module.exports = __webpack_public_path__ + "img/tm_footer_symbol.c9c821a3.svg";